import type { ValidationError } from 'validation/validators'

export const unknownError = (): ValidationError => ({
  message: 'UnknownError',
  tag: 'ValidationError',
  path: [],
})
